'use client';
import { MANIFEST_ICONS } from '../manifest/icons.js';
import { getSameKeyValueMapForManifest, manifestResolve } from './manifest.utils.js';
import { SwanAssetFolders } from '../types/enums.js';

const SWAN_ICON_KEY_MAP = getSameKeyValueMapForManifest(MANIFEST_ICONS);
const SWAN_DEPRECATED_ICONS = Object.keys(MANIFEST_ICONS).filter((o)=>void 0 !== MANIFEST_ICONS[o].deprecated);
function getSwanIconUrl(e, i, n) {
    return manifestResolve(MANIFEST_ICONS, e, SwanAssetFolders.ICONS, i, n);
}

export { SWAN_DEPRECATED_ICONS, SWAN_ICON_KEY_MAP, getSwanIconUrl };
